import { render } from "./pseModal.vue?vue&type=template&id=83d74e34"
import script from "./pseModal.vue?vue&type=script&lang=js"
export * from "./pseModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__